import React from 'react';
import { Space, Typography, DatePicker, InputNumber } from 'antd';
import dayjs from 'dayjs';
import { StrategyPhase } from '../ProfitScenario/types';

const { Text } = Typography;

interface PhaseControlsProps {
    phase: StrategyPhase;
    updatePhaseInfo: (phaseId: string, updates: any) => void;
}

export const PhaseControls: React.FC<PhaseControlsProps> = ({ phase, updatePhaseInfo }) => {
    return (
        <Space style={{ marginBottom: 16 }}>
            <Text>阶段名称:</Text>
            <Text
                editable={{
                    onChange: (value) => updatePhaseInfo(phase.id, { name: value }),
                    tooltip: '点击编辑',
                }}
                strong
                style={{ color: '#333' }}
            >
                {phase.name}
            </Text>

            <Text>开始日期:</Text>
            <DatePicker
                value={phase.startDate ? dayjs(phase.startDate) : undefined}
                onChange={(_, dateString) => updatePhaseInfo(phase.id, { startDate: dateString as string })}
            />

            <Text>周数范围:</Text>
            <InputNumber
                min={1}
                max={13}
                value={phase.startWeek}
                onChange={v => updatePhaseInfo(phase.id, { startWeek: v || 1 })}
            />
            <Text>-</Text>
            <InputNumber
                min={1}
                max={13}
                value={phase.endWeek}
                onChange={v => updatePhaseInfo(phase.id, { endWeek: v || 1 })}
            />
        </Space>
    );
};
